import EditNameIcon from '@/common/assets/icons/editNameIcon.svg?react';
import { ExtensionProps } from '@/common/components/imageGallery/types/imageCard.type';
import { Box } from 'styled-system/jsx';

export const EditNameExtension = ({ onClick }: ExtensionProps) => {
  return (
    <Box onClick={onClick} position="absolute" top="0.5rem" left="0.5rem">
      <EditNameIcon />
    </Box>
  );
};
